import { render, staticRenderFns } from "./IntegralGoodCon.vue?vue&type=template&id=d467c678&scoped=true"
import script from "./IntegralGoodCon.vue?vue&type=script&lang=js"
export * from "./IntegralGoodCon.vue?vue&type=script&lang=js"
import style0 from "./IntegralGoodCon.vue?vue&type=style&index=0&id=d467c678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d467c678",
  null
  
)

export default component.exports